/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsSetCurrency } from "../../funcs/budgetsSetCurrency.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SetCurrencyRequestBody$inboundSchema,
};

export const tool$budgetsSetCurrency: ToolDefinition<typeof args> = {
  name: "budgets-set-currency",
  description: `Set display currency

ISO 4217 code used for display on budgets and cost reports. No conversion is performed anywhere.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsSetCurrency(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
